//* eslint-disable no-undef */
import React, { Component } from "react";
import ToastService from "../../../services/ToastService";
import MasterService from "../../../services/MasterService";
import ProductService from "../../../services/ProductService";
import nofileSvg from "../../../public/nofile.svg";
import { showLoading } from "react-global-loading";

const userData = localStorage.getItem("persist:root")
  ? JSON.parse(JSON.parse(localStorage.getItem("persist:root")).userData)
  : "";

class AddEditProduct extends Component {
  constructor(props) {
    super(props);
    const query = new URLSearchParams(this.props.location?.search);
    this.maxProductEffectiveLength = 250; // Adjust the value as per requirement
    this.maxIngredientLength = 200;
    this.maxShortDescriptionLength = 300;
    this.maxLegalDisclaimerLength = 150;
    this.state = {
      productId: query.get("id") || "",
      categories: [],
      countries: [],
      selectedCountry: "",
      selectedCategory: [],
      selectedImages: [],
      imageApi: "",
      proStatus: "",
      postTitle: "",
      postContent: "",
      productPrice: "",
      stockAvailable: false,
      linkOne: "",
      linkTwo: "",
      linkThree: "",
      productEffective: "",
      ingredient: "",
      shortDescription: "",
      legal: "",
      weight: "",
      brand: "",
      quantity: "",
      country: "",
      category: "",
      form: "",
      errors: {
        postTitle: "",
        postContent: "",
        productPrice: "",
        linkOne: '',
        linkTwo: '',
        linkThree: '',
        weight: '',
        quantity: ''
      }
    };
  }

  componentDidMount() {
    const { productId } = this.state;
    if (productId) {
      showLoading(true);
      this.getProductById(productId);
    }
    this.getCategories();
    this.getCountries();
  }

  getQueryParam = (param) => {
    const query = new URLSearchParams(this.props.location?.search);
    return query.get(param) || "";
  };

  getProductById = async (id) => {
    try {
      const result = await ProductService.getProductById({ p: id });
      if (!result) return;

      const product = result[0];
      this.setState({
        selectedCategory: product.category[0].name,
        selectedCountry: product.country.id,
        imageApi: product.product_image[0],
        postTitle: product.post_title,
        postContent: product.post_content,
        productPrice: product.product_price,
        stockAvailable: product.stock_available,
        linkOne: product.link_one,
        linkTwo: product.link_two,
        linkThree: product.link_three,
        productEffective: product.product_effective,
        shortDescription: product.post_content,
        legal: product.legal,
        weight: product.weight,
        brand: product.brand,
        quantity: product.item_number,
        ingredient: product.ingredient,
        form: product.form,
      });
      showLoading(false);
    } catch (err) {
      console.error(err);
    }
  };

  deleteImage = () => this.setState({ imageApi: "" });

  getCountries = async () => {
    try {
      const countries = await MasterService.getAyushCountries();
      if (countries) this.setState({ countries });
    } catch (err) {
      console.error(err);
    }
  };

  getCategories = async () => {
    try {
      const categories = await MasterService.getCategories();
      if (categories) this.setState({ categories });
    } catch (err) {
      console.error(err);
    }
  };

  onImageSelection = (event) => {
    this.setState({ imageApi: event.target.files[0] });
  };

  validateProductPrice = (price) => /^\d+(\.\d{1,2})?$/.test(price) && price > 0;

  handleFieldChange = (field, value) => {
    const errors = { ...this.state.errors };
    const urlPattern = new RegExp(
      "^(https?:\\/\\/)?([\\da-z.-]+)\\.([a-z.]{2,6})([\\/\\w .-]*)*\\/?$"
    );
    if (field === 'postTitle' && /[^a-zA-Z0-9 ]/.test(value)) {
      errors.postTitle = "Special characters are not allowed in the product name.";
    } else if (field === 'postContent' && value.length > 250) {
      errors.postContent = "Description cannot exceed 250 characters.";
    } else if (field === 'productPrice' && !this.validateProductPrice(value)) {
      errors.productPrice = "Please enter a valid price (numeric and greater than 0).";
    } else if ((field === 'linkOne' || field === 'linkTwo' || field === 'linkThree') && value && !urlPattern.test(value)) {
      errors[field] = "Please enter a valid URL.";
    } else if ((field === 'weight' || field === 'quantity') && (!/^\d+$/.test(value) || value <= 0)) {
      errors[field] = `${field === 'weight' ? 'Product Quantity' : 'Package Quantity'} must be a positive number.`;
    } else {
      errors[field] = ""; // Clear the error if valid
    }


    this.setState({ [field]: value, errors });
  };

  onProductCreateUpdate = async () => {
    const {
      selectedCategory,
      selectedCountry,
      postTitle,
      postContent,
      productPrice,
      stockAvailable,
      linkOne,
      linkTwo,
      linkThree,
      productEffective,
      shortDescription,
      legal,
      weight,
      brand,
      quantity,
      ingredient,
      form,
      imageApi,
      productId,
      proStatus,
    } = this.state;

    if (
      !selectedCategory ||
      !postTitle ||
      !postContent ||
      !productPrice ||
      !imageApi ||
      (!userData.blog_id?.userblog_id && userData.roles !== 'administrator') ||
      (userData.roles === 'administrator' && !selectedCountry)
    ) {
      return ToastService.error("Please fill required details");
    }

    showLoading(true);
    const formData = new FormData();
    formData.append("post_title", postTitle);
    formData.append("post_content", postContent);
    formData.append("product_price", productPrice);
    formData.append("stock_available", stockAvailable);
    formData.append("link_one", linkOne);
    formData.append("link_two", linkTwo);
    formData.append("link_three", linkThree);
    formData.append("product_effective", productEffective);
    formData.append("ingredient", ingredient);
    formData.append("short_description", shortDescription);
    formData.append("legal", legal);
    formData.append("weight", weight);
    formData.append("lang", localStorage.getItem('localLang'));
    formData.append("post_status", proStatus || userData.roles === "administrator");
    formData.append("brand", brand);
    formData.append("quantity", quantity);
    formData.append("form", form);
    formData.append("item_number", quantity);
    formData.append("country", selectedCountry || userData.blog_id?.userblog_id);
    formData.append("category", selectedCategory);
    formData.append("product_image", imageApi);

    try {
      const result = productId ? await ProductService.updateProduct(formData) : await ProductService.addProduct(formData);
      showLoading(false);
      const message = result.data.message;

      if (result.status === 200) {
        window.history.back();
        ToastService.success(message);

      } else {
        ToastService.error(message);
      }
    } catch (error) {
      showLoading(false);
      console.error(error);
    }
  };

  handleFieldBlur = (field) => {
    const { postTitle, postContent, productPrice, errors, weight, quantity } = this.state;

    // Additional blur validation for each field
    if (field === 'productPrice' && !this.validateProductPrice(productPrice)) {
      errors.productPrice = "Please enter a valid price (numeric and greater than 0).";
    }

    if (field === 'postTitle' && /[^a-zA-Z0-9 ]/.test(postTitle)) {
      errors.postTitle = "Special characters are not allowed in the product name.";
    }

    if (field === 'postContent' && /[^a-zA-Z0-9 ]/.test(postContent)) {
      errors.postContent = "Special characters are not allowed in the product description.";
    }
    if (field === 'weight' && (!/^\d+$/.test(weight) || weight <= 0)) {
      errors.weight = "Product Quantity must be a positive number.";
    }

    if (field === 'quantity' && (!/^\d+$/.test(quantity) || quantity <= 0)) {
      errors.quantity = "Package Quantity must be a positive number.";
    }
    this.setState({ errors });
  };

  onShortDescription = desc => {
    desc.length > 250
      ? ToastService.error("The text may not be longer than 250 characters.")
      : this.setState({ shortDescription: desc });
  };
  render() {
    const {
      errors,
      countries,
      categories,
      selectedCategory,
      selectedCountry,
      postTitle,
      postContent,
      productPrice,
      stockAvailable,
      linkOne,
      linkTwo,
      linkThree,
      productEffective,
      shortDescription,
      legal,
      weight,
      brand,
      quantity,
      ingredient,
      form,
      imageApi,
      productId
    } = this.state;

    return (
      <>
        <div className="container p-4 bg-white pmloginscrn">

          <div className="row fixrd pnkbg p-3 mt-3 mb-4 rounded rounded-2 m-ver-col stickrw">
            <div className="col-md-8 head-title">
              <h4 className="adphd t0">{productId ? "Edit" : "Add"} Product</h4>
            </div>
            <div className="col-md-4 bgp text-end m-btn addproductcol">
              <button
                onClick={() => window.history.back()}
                className="card-link rounded rounded-2 w-100 btntxdsh lightbtn"
              >
                Discard
              </button>
              <button
                onClick={() => this.onProductCreateUpdate()}
                className="card-link rounded rounded-2 w-100 btntxdsh darkbtn"
              >
                {productId ? "Save " : "Add "}Product
              </button>
            </div>
          </div>

          {/* Product Image Upload */}
          <div className="row mt-4 m-ver-col spupp mversupp mrtpsupp">
            <div className="col-md-6 m-imgupload">
              <div className="box-zoom">
                {imageApi ? (
                  <>
                    <img
                      src={
                        imageApi.length > 0
                          ? imageApi
                          : URL.createObjectURL(imageApi)
                      }
                      className="imgcon"
                      alt="product"
                    />
                    <div>
                      <button onClick={() => this.deleteImage()}>
                        <i className="fa fa-trash" aria-hidden="true"></i>
                      </button>
                    </div>
                  </>
                ) : (
                  <div className="upload-drag d-flex align-items-center justify-content-center upbdr">
                    <div className="uploadbox">
                      <img
                        src={nofileSvg}
                        className="d-block noimg"
                        alt="upload"
                      />
                      <span className="d-block">Upload Image by clicking </span>
                      <small className="text-muted d-block mt-2">
                        Recommended image size: 500x500 pixels.
                      </small>
                      <label htmlFor="productname" id="uploadimagg" className="bldlbl">
                        Image of the product <span className="text-danger">*</span>
                      </label>
                      <input
                        className="upload-btn"
                        aria-labelledby="uploadimagg"
                        type="file"
                        accept=".png, .jpg, .jpeg"
                        name="file"
                        onChange={e => this.onImageSelection(e)}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Product Details */}
            <div className="col-md-6">
              <div className="form-group mb-4 position-relative">
                <label htmlFor="productname" id="productname" className="bldlbl t2">
                  Name of the Product <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  aria-labelledby="postTitle"
                  name="postTitle"
                  value={postTitle}
                  onChange={e => this.handleFieldChange('postTitle', e.target.value)}
                  onBlur={() => this.handleFieldBlur('postTitle')}
                />
                {errors.postTitle && (
                  <div className="text-danger">{errors.postTitle}</div>
                )}
              </div>

              <div className="form-group position-relative">
                <label htmlFor="productdescription" id="aboutproduct" className="bldlbl t2">
                  About this product <span className="text-danger">*</span>
                </label>
                <textarea
                  aria-labelledby="aboutproduct"
                  placeholder="Enter Description (250 words)"
                  className="form-control"
                  rows="3"
                  value={postContent}
                  onChange={e => this.handleFieldChange('postContent', e.target.value)}
                  onBlur={() => this.handleFieldBlur('postContent')}
                />
                {errors.postContent && (
                  <div className="text-danger">{errors.postContent}</div>
                )}
              </div>
            </div>
          </div>

          {/* Product Price and Stock */}
          <div className="row mt-4">
            <div className="col-md-6">
              <div className="form-group position-relative">
                <label htmlFor="prodprice" id="prodprice" className="bldlbl t2">
                  Product Price <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  aria-labelledby="prodprice"
                  name="productprice"
                  value={productPrice}
                  onChange={e => this.handleFieldChange('productPrice', e.target.value)}
                  onBlur={() => this.handleFieldBlur('productPrice')}
                />
                {errors.productPrice && (
                  <div className="text-danger">{errors.productPrice}</div>
                )}
              </div>
            </div>
            <div className="col-md-6">
              <div className="btn-group event-check w-100">
                <label
                  id="stockavailable"
                  className={`btn btn-outline-dark border mt-4 ${stockAvailable ? "active" : ""}`}
                  onClick={() => this.setState({ stockAvailable: !stockAvailable })}
                >
                  Stock Available
                </label>
                <input
                  aria-labelledby="stockavailable"
                  type="checkbox"
                  value={stockAvailable}
                  checked={stockAvailable}
                  style={{ display: "none" }}
                  onChange={() => { }}
                />
              </div>
            </div>
          </div>

          {/* Product Links */}
          <div className="mt-4 p-des">
            <span className="bldlbl mt-2 t2">Enter the Online Availability links</span>
          </div>
          <div className="mt-2 col-12 editlink-box">
            <div className="row">
              {[{ name: 'Link 1', value: linkOne, field: 'linkOne' },
              { name: 'Link 2', value: linkTwo, field: 'linkTwo' },
              { name: 'Link 3', value: linkThree, field: 'linkThree' }].map((link, index) => (
                <div className="col-md-4 position-relative m-fg" key={index}>
                  <label className="bldlbl t2" id={`avblink${index + 1}`} htmlFor={`btncheck${index + 1}`}>
                    {link.name}
                  </label>
                  <input
                    placeholder={link.name}
                    aria-labelledby={`avblink${index + 1}`}
                    className="form-control position-relative"
                    onChange={e => this.handleFieldChange(link.field, e.target.value)}
                    value={link.value}
                  />
                  {errors[link.field] && (
                    <span className="text-danger">{errors[link.field]}</span>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* Product Effectiveness & Ingredients */}
          <div className="row mt-4 my-4 bg-dark-subtle highlighted-row py-3 rounded rounded-4 mtb0">
            <div className="col-md-6 border-end border-4 border-white pdlr0">
              <div className="form-group position-relative mt-3 highlightedtdcol">
                <label className="bldlbl t2" id="prodeffec" htmlFor="prodeffec">
                  What is this Product effective for
                </label>
                <textarea
                  className="form-control edit-pro-feild"
                  aria-labelledby="prodeffec"
                  placeholder="Enter the details here"
                  rows="3"
                  maxLength={this.maxProductEffectiveLength}
                  onChange={e => this.setState({ productEffective: e.target.value })}
                  value={productEffective}
                />
                {productEffective.length > this.maxProductEffectiveLength && (
                  <div className="text-danger">
                    Character limit exceeded! Max {this.maxProductEffectiveLength} characters allowed.
                  </div>
                )}
              </div>
            </div>

            <div className="col-md-6 px-4 pdlr0">
              <div className="form-group position-relative mt-3">
                <label className="bldlbl t2" id="prodingreds" htmlFor="prodingreds">
                  Write product ingredients
                </label>
                <textarea
                  className="form-control edit-pro-feild"
                  aria-labelledby="prodingreds"
                  placeholder="Enter the ingredient details here"
                  rows="3"
                  maxLength={this.maxIngredientLength}
                  onChange={e => this.setState({ ingredient: e.target.value })}
                  value={ingredient}
                />
                {ingredient.length > this.maxIngredientLength && (
                  <div className="text-danger">
                    Character limit exceeded! Max {this.maxIngredientLength} characters allowed.
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Product Description and Legal Disclaimer */}
          <div className="row">
            <div className="col-12">
              <div className="form-group position-relative mt-3">
                <label className="bldlbl t2" id="prodshortdesc" htmlFor="prodshortdesc">
                  Short product description
                </label>
                <textarea
                  className="form-control edit-pro-feild"
                  aria-labelledby="prodshortdesc"
                  placeholder="Enter the Product description here"
                  rows="3"
                  maxLength={this.maxShortDescriptionLength}
                  onChange={e => this.onShortDescription(e.target.value)}
                  value={shortDescription}
                />
                {shortDescription.length > this.maxShortDescriptionLength && (
                  <div className="text-danger">
                    Character limit exceeded! Max {this.maxShortDescriptionLength} characters allowed.
                  </div>
                )}
              </div>

              <div className="mt-4">
                <div className="form-group position-relative mt-3">
                  <label className="bldlbl t2" id="prodlegaldesc" htmlFor="prodlegaldesc">
                    Legal Disclaimer
                  </label>
                  <textarea
                    className="form-control edit-pro-feild"
                    aria-labelledby="prodlegaldesc"
                    placeholder="Enter the legal Disclaimer here"
                    rows="3"
                    maxLength={this.maxLegalDisclaimerLength}
                    onChange={e => this.setState({ legal: e.target.value })}
                    value={legal}
                  />
                  {legal.length > this.maxLegalDisclaimerLength && (
                    <div className="text-danger">
                      Character limit exceeded! Max {this.maxLegalDisclaimerLength} characters allowed.
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Product Details Table */}
          <p className="mt-4">
            <b className="t1">Product Details</b>
            <hr />
          </p>
          <table className="table product-des-table">
            <tbody>
              {/* Domain Field */}
              <tr>
                <th className="t2" width="30%">Domain *</th>
                <td>
                  <div className="form-group">
                    <select
                      name="orderby"
                      className="form-select"
                      aria-label="Shop order"
                      value={selectedCategory}
                      onChange={e => this.setState({ selectedCategory: e.target.value })}
                    >
                      <option defaultValue="selected">Select Domain</option>
                      {categories.map((item, index) => (
                        <option key={index} value={item.name}>{item.name}</option>
                      ))}
                    </select>
                  </div>
                </td>
              </tr>

              {/* Country Field (for Admin users only) */}
              {userData.roles === "administrator" && (
                <tr>
                  <th className="t2">Country *</th>
                  <td>
                    <div className="form-group">
                      <select
                        name="orderby"
                        className="form-select"
                        aria-label="Shop order"
                        value={selectedCountry}
                        onChange={e => this.setState({ selectedCountry: e.target.value })}
                      >
                        <option defaultValue="selected">Countries*</option>
                        {countries.map((item, index) => (
                          <option key={index} value={item.id}>{item.blogname}</option>
                        ))}
                      </select>
                    </div>
                  </td>
                </tr>
              )}

              {/* Brand Field */}
              <tr>
                <th className="t2">Brand</th>
                <td>
                  <div className="form-group">
                    <label className="bldlbl" id="prodbrand" htmlFor="prodbrand">Product brand</label>
                    <input
                      type="text"
                      aria-labelledby="prodbrand"
                      onChange={e => this.setState({ brand: e.target.value })}
                      value={brand}
                      className="form-control"
                      placeholder="Enter the brand"
                      name="productbrand"
                    />
                  </div>
                </td>
              </tr>

              {/* Form Field */}
              <tr>
                <th className="t2">Form</th>
                <td>
                  <div className="form-group">
                    <select
                      value={form}
                      onChange={e => this.setState({ form: e.target.value })}
                      className="form-select"
                      aria-label="select domain"
                    >
                      <option value="" selected>Select Form</option>
                      {["Solid", "Liquid", "Gel"].map((item, index) => (
                        <option key={index} value={index + 1}>{item}</option>
                      ))}
                    </select>
                  </div>
                </td>
              </tr>

              {/* Quantity per Unit */}
              <tr>
                <th className="t2">Quantity (gm/ml)</th>
                <td>
                  <div className="form-group">
                    <label className="bldlbl" id="prodqty" htmlFor="prodqty">Quantity per unit</label>
                    <input
                      type="text"
                      aria-labelledby="prodqty"
                      onChange={e => this.handleFieldChange('weight', e.target.value)}
                      onBlur={() => this.handleFieldBlur('weight')}
                      value={weight}
                      className="form-control"
                      placeholder="Enter the product quantity"
                      name="productweight"
                    />
                    {errors.weight && <span className="text-danger">{errors.weight}</span>}
                  </div>
                </td>
              </tr>

              {/* Package Quantity */}
              <tr>
                <th className="t2">Package Quantity</th>
                <td>
                  <div className="form-group">
                    <label className="bldlbl" id="pkgqty" htmlFor="pkgqty">Package quantity</label>
                    <input
                      type="text"
                      aria-labelledby="pkgqty"
                      onChange={e => this.handleFieldChange('quantity', e.target.value)}
                      onBlur={() => this.handleFieldBlur('quantity')}
                      value={quantity}
                      className="form-control"
                      placeholder="Enter package quantity"
                      name="itemquantity"
                    />
                    {errors.quantity && <span className="text-danger">{errors.quantity}</span>}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </>
    );

  }
}
export default AddEditProduct;
